import {
  CanvasZone,
  Role,
  SupportedDevice,
  WorkflowPageConfig,
  WorkflowWidgetConfig,
  WorkflowZoneConfig,
} from '@finxone-platform/shared/sys-config-types';

export class CopyWidget {
  static readonly type = '[CopyPaste] CopyWidget';
  constructor(public widgetConfig: WorkflowWidgetConfig) {}
}

export class CopyWidgets {
  static readonly type = '[CopyPaste] CopyWidgets';
  constructor(public widgetConfigs: WorkflowWidgetConfig[]) {}
}

export class CopySelectedWidgets {
  static readonly type = '[CopyPaste] CopySelectedWidgets';
}
export class CopyRenderingEngineSelectedWidgets {
  static readonly type = '[CopyPaste] CopyRenderingEngineSelectedWidgets';
}

export class DeleteSelectedWidgets {
  static readonly type = '[CopyPaste] DeleteSelectedWidgets';
}

export class PasteWidget {
  static readonly type = '[CopyPaste] PasteWidget';
  constructor(public targetPageLayout?: string) {}
}

export class PastePersona {
  static readonly type = '[CopyPaste] PastePersona';
  constructor(public targetPersona: string) {}
}

export class CopyPage {
  static readonly type = '[CopyPaste] CopyPage';
  constructor(public pageConfig: WorkflowPageConfig) {}
}

export class CopyZone {
  static readonly type = '[CopyPaste] CopyZone';
  constructor(public zoneConfig: CanvasZone, public zone: string) {}
}

export class CopyZoneDevice {
  static readonly type = '[CopyPaste] CopyZoneDevice';
  constructor(
    public zoneDeviceConfig: WorkflowZoneConfig,
    public zone: string,
    public device: SupportedDevice,
  ) {}
}

export class CopyPersona {
  static readonly type = '[CopyPaste] CopyPersona';
  constructor(public persona: Role) {}
}

export class PastePage {
  static readonly type = '[CopyPaste] PastePage';
  constructor(public shouldNotOverwriteUrl = true) {}
}

export class PasteZone {
  static readonly type = '[CopyPaste] PasteZone';
  constructor(public targetPersona: string) {}
}

export class PasteZoneDevice {
  static readonly type = '[CopyPaste] PasteZoneDevice';
  constructor(public zone: string, public device: SupportedDevice, public targetPersona: string) {}
}

export class PastePageProperties {
  static readonly type = '[CopyPaste] PastePageProperties';
}
